<template>
  <div :id="attachId" class="attach-container">
    <v-row v-for="(entry, index) in times" :key="index" dense class="mb-2">
      <v-col cols="3">
        <validation-provider
          v-slot="{ errors }"
          rules="time"
          mode="eager"
          name="Начало"
        >
          <v-text-field
            v-model="entry.time_begin"
            label="Начало"
            placeholder="чч:мм"
            outlined
            dense
            hide-details
            :error-messages="errors"
          >
            <template v-slot:append>
              <v-tooltip v-if="errors.length > 0" top color="error">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" dark v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>{{ errors.join("\n") }}</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col cols="3">
        <validation-provider
          v-slot="{ errors }"
          rules="time"
          mode="eager"
          name="Окончание"
        >
          <v-text-field
            v-model="entry.time_end"
            label="Окончание"
            placeholder="чч:мм"
            outlined
            dense
            hide-details
            :error-messages="errors"
          >
            <template v-slot:append>
              <v-tooltip v-if="errors.length > 0" top color="error">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="error" dark v-bind="attrs" v-on="on">
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>{{ errors.join("\n") }}</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>
      <v-col cols="6">
        <div class="d-flex align-center">
          <v-text-field
            v-model="entry.time_text"
            label="Замещающий текст"
            outlined
            dense
            hide-details
          />
          <action-col-btn
            v-if="canRemove(index) && !readonly"
            color="primary"
            tooltip="Удалить время"
            class="ml-2"
            @click="deleteTime(index)"
          >
            mdi-close-circle-outline
          </action-col-btn>
        </div>
      </v-col>
    </v-row>
    <v-row dense class="justify-end">
      <v-col class="flex-grow-0">
        <v-btn
          v-if="!readonly"
          depressed
          outlined
          color="primary"
          @click="addTime"
          >Добавить время</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    attachId: {
      type: String,
      default: "dtarray"
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    times: {
      get() {
        return this.value;
      },
      set(v) {
        const ar = v.filter(time => {
          const match = time.match(/(\d\d):(\d\d)/);
          if (!match) return false;
          const hour = parseInt(match[1]);
          if (isNaN(hour) || hour >= 24) return false;
          const minute = parseInt(match[2]);
          if (isNaN(minute) || minute >= 60) return false;
          return true;
        });
        ar.sort();
        this.$emit("input", ar);
      }
    },
    dic() {
      return Array.from(Array(24).keys()).map(hour => {
        const hourPad = hour < 10 ? `0${hour}` : `${hour}`;
        const value = `${hourPad}:00`;
        return {
          value,
          term: value
        };
      });
    }
  },
  methods: {
    canRemove() {
      return true;
    },
    addTime() {
      const { times } = this;
      this.$set(times, times.length, {
        time_begin: "",
        time_end: "",
        time_text: ""
      });
      this.$emit("input", times);
    },
    deleteTime(index) {
      const { times } = this;
      this.$delete(times, index);
      this.$emit("input", times);
    }
  }
};
</script>

<style scoped lang="scss">
.attach-container {
  position: relative;
}
</style>
